import { InvalidArticleError } from '../../domain/errors/InvalidArticleError';
import type { ArticleRepository } from '../../domain/repositories/ArticleRepository.interface';
import type { ArticleCategory } from '../../domain/entities/Article.entity';
import type { ArticleDto } from '../dto/ArticleDto';
import { ApplicationError, ValidationError, type Logger } from '@dma/shared';

export class GetArticleBySlugUseCase {
  constructor(
    private readonly repository: ArticleRepository,
    private readonly logger: Logger
  ) {}

  public async execute(category: ArticleCategory, slug: string): Promise<ArticleDto> {
    let article;
    try {
      article = await this.repository.getPublishedBySlug(category, slug);
    } catch (error) {
      if (error instanceof InvalidArticleError) {
        this.logger.error('Article content failed domain validation', {
          category,
          slug,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('ARTICLE_UNAVAILABLE', 'این مطلب در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }

    if (!article) {
      throw new ValidationError(`مطلبی با شناسه‌ی "${slug}" یافت نشد.`);
    }

    return article.props;
  }
}
